import {FormProps} from 'platform/components';

import {GetGeneralSettingApiResponse} from '@dms/api/core';

import {TiresInventoryFormType} from '../schemas/tiresInventoryFormSchema';

export const getDefaultValuesFromGeneralSettings = (
  data: GetGeneralSettingApiResponse
): FormProps<TiresInventoryFormType>['defaultValues'] => ({
  ...data,
  hasAutomaticStoreUntilSettings: data?.hasAutomaticStoreUntilSettings ?? false,
  documentSettings: {
    receiptNote: data?.documentSettings?.receiptNote ?? {docSeriesId: ''},
    issueNote: data?.documentSettings?.issueNote ?? {docSeriesId: ''},
    archiveNote: data?.documentSettings?.archiveNote ?? {docSeriesId: ''},
    tireOrder: data?.documentSettings?.tireOrder ?? {docSeriesId: ''},
    tireSet: data?.documentSettings?.tireSet ?? {docSeriesId: ''},
  },
  storeUntilSettings: data?.storeUntilSettings?.map((store) => ({
    preFillDate: {
      month: store?.preFillDate?.month ?? undefined,
      day: store?.preFillDate?.day ?? undefined,
    },
    receivedAt: {
      month: store?.receivedAt?.month ?? undefined,
      day: store?.receivedAt?.day ?? undefined,
    },
    receivedTo: {
      month: store?.receivedTo?.month ?? undefined,
      day: store?.receivedTo?.day ?? undefined,
    },
  })),
});
